<template>
	<div class="admin-login">
		<form class="admin-login__form" @submit.prevent="submit">
			<h1>Blog Admin</h1>

			<div class="admin-login__field">
				<label>Username</label>
				<input
					v-model="username"
					type="text"
					autocomplete="username"
					required
				/>
			</div>

			<div class="admin-login__field">
				<label>Password</label>
				<input
					v-model="password"
					type="password"
					autocomplete="current-password"
					required
				/>
			</div>

			<p v-if="error" class="admin-login__error">{{ error }}</p>

			<button type="submit" :disabled="loading">
				{{ loading ? "Logging in…" : "Log in" }}
			</button>
		</form>
	</div>
</template>

<script setup>
import { useRouter } from "vue-router";
import api from "@/api/index.js";

const router = useRouter();

const username = ref("");
const password = ref("");
const loading = ref(false);
const error = ref("");

onMounted(() => {
	if (localStorage.getItem("sid")) {
		router.push({ name: "BlogAdmin" });
	}
});

async function submit() {
	loading.value = true;
	error.value = "";
	try {
		const res = await api.adminLogin({
			username: username.value,
			password: password.value,
		});
		const sid = res.data.sid;
		localStorage.setItem("sid", sid);
		sessionStorage.sid = sid;
		router.push({ name: "BlogAdmin" });
	} catch (err) {
		error.value = err?.response?.data?.message ?? "Invalid credentials.";
	} finally {
		loading.value = false;
	}
}
</script>

<style scoped lang="scss">
.admin-login {
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f5f7fc;
}

.admin-login__form {
	background: #fff;
	padding: 40px;
	border-radius: 8px;
	box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
	width: 100%;
	max-width: 360px;
	display: flex;
	flex-direction: column;
	gap: 16px;
	color: #333;

	h1 {
		margin: 0 0 8px;
		font-size: 22px;
	}
}

.admin-login__field {
	display: flex;
	flex-direction: column;
	gap: 4px;

	label {
		font-size: 13px;
		font-weight: 600;
	}
	input {
		padding: 8px 10px;
		border: 1px solid #ccc;
		border-radius: 4px;
		font-size: 15px;
		color: #333;
	}
}

.admin-login__error {
	color: #c0392b;
	font-size: 13px;
	margin: 0;
}

button {
	padding: 10px;
	background: #142c3a;
	color: #fff;
	border: none;
	border-radius: 4px;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
}
</style>
